import { render, staticRenderFns } from "./receiveemail.vue?vue&type=template&id=3f38e0e6&"
import script from "./receiveemail.vue?vue&type=script&lang=js&"
export * from "./receiveemail.vue?vue&type=script&lang=js&"
import style0 from "./receiveemail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports